<template>
  <div class="purchase-intent-error">
    <ns-toast-vue
      custom
      theme="error"
      type="fleeting"
      toast-event-name="purchaseIntentError"
      duration="8000"
    >
      <template v-slot:custom>
        <div class="claim-message">
          <ns-icon icon-name="icon-error-lg" />
          <span>{{ tdc.tdc_purchaseIntentError }}</span>
        </div>
      </template>
    </ns-toast-vue>
  </div>
</template>

<script>
import { NsIcon } from '@nuskin/ns-icon'
import config from '../../js/qualificationsConfigService'

export default {
  name: 'PurchaseIntentError',
  components: {
    NsIcon,
  },
  computed: {
    tdc() {
      return config.getTdc()
    },
  },
}
</script>

<style lang="scss">
.purchase-intent-error {
  .custom {
    display: flex;
    align-items: center;
  }

  .claim-message {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    margin: 0 auto;
    padding: 15px;

    .icon {
      margin-right: 10px;
    }
  }
}
</style>
